<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="popup-error">
    <!-- Support PC Tablet -->
    <b-modal
      v-if="windowWidth >= 600 && windowHeight >= 600"
      id="modal-error"
      ref="my-modal-error"
      centered
      class="modal-Error"
      crm_at="modal_error"
      hide-footer
    >
      <div :class="currentLocale">
        <div class="text-center">
          <img class="icon-error" src="@/assets/images/icon_Error.svg" alt="" />
        </div>
        <div
          class="text-center pb-4 pt-3 modal-error-text-main"
          crm_at="detail_error"
        >
          {{ Title }}
        </div>
        <div
          class="text-center pb-4 modal-error-text-sub"
          crm_at="detail_error"
          v-html="Detail"
        ></div>
        <button
          :style="{
            'background-color': backgroundColor ? backgroundColor : '#1890ff',
            'border-color': backgroundColor ? backgroundColor : '#1890ff',
            color: textColor ? textColor : '#FFF',
          }"
          type="submit"
          value="Submit"
          crm_at="btn_submit"
          class="btn-alert-error"
          @click="close"
        >
          {{ lbl.btn.submit }}
        </button>
      </div>
    </b-modal>

    <!-- Support Mobile -->
    <b-modal
      v-else
      id="modal-error"
      ref="my-modal-error"
      centered
      class="modal-Error"
      crm_at="modal_error"
      hide-footer
    >
      <template #modal-header="{ close }">
        <div :class="currentLocale">
          <div class="row">
            <div class="col-8">
              <h5 class="modal-title" crm_at="title_error">
                {{ Title }}
              </h5>
            </div>
            <div class="col-4 text-end">
              <b-button
                size="lg"
                class="b-modal-header close-modal-btn"
                crm_at="close_error"
                @click="close()"
              >
                <a-icon type="close" />
              </b-button>
            </div>
          </div>
        </div>
      </template>
      <div class="row">
        <div
          class="col-12 text-center pt-4 pb-4 b-modal-body"
          crm_at="detail_error"
          v-html="Detail"
        ></div>
        <div
          v-if="Log != null"
          class="col-12 text-right pt-0 pb-0 b-log-error"
          crm_at="log_error"
        >
          Log : {{ Log }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Locale from '@/helper/Locale.js'

export default {
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    show: Boolean,
    data: Object,
  },
  data() {
    return {
      Title: '',
      Detail: '',
      Log: null,
      backgroundColor: '',
      textColor: '',
      currentLocale: Locale.getLocale(),
    }
  },
  watch: {
    show: function (newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      if (newVal == true) {
        this.genInfo()
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'modal-error') {
        this.$refs['my-modal-error'].hide()
        this.$emit('changeError', false)
      }
    })
  },
  methods: {
    genInfo() {
      if (this.data != null) {
        if (this.data.title != null && this.data.title != undefined) {
          this.Title = this.data.title
            ? this.data.title
            : this.lbl.error.errortitle
        } else {
          this.Title = this.lbl.error.errortitle
        }
        if (this.data.detail != null && this.data.detail != undefined) {
          this.Detail = this.data.detail
            ? this.data.detail
            : this.lbl.error.connectionproblem
        } else {
          this.Detail = this.lbl.error.connectionproblem
        }
        if (
          this.data.backgroundColor != null &&
          this.data.backgroundColor != undefined
        ) {
          this.backgroundColor = this.data.backgroundColor
            ? this.data.backgroundColor
            : '#1890ff'
        } else {
          this.backgroundColor = '#1890ff'
        }
        if (this.data.textColor != null && this.data.textColor != undefined) {
          this.textColor = this.data.textColor ? this.data.textColor : '#FFF'
        } else {
          this.textColor = '#FFF'
        }
        if (this.data.log != null && this.data.log != undefined) {
          this.Log = this.data.log ? this.data.log : null
        } else {
          this.Log = null
        }
        this.$refs['my-modal-error'].show()
      } else {
        this.$refs['my-modal-error'].hide()
        this.$emit('changeError', false)
      }
    },
    close() {
      this.$refs['my-modal-error'].hide()
      this.$emit('changeError', false)
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
#modal-error {
  .modal-header {
    background-color: #ffe1e0;
    display: block;
  }

  .text-end {
    text-align: end;
  }

  .b-modal-body {
    font-size: 15px;
  }

  .b-log-error {
    color: #d9d9d9;
  }
}

@media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
  #modal-error {
    .modal-header {
      background-color: #ffffff;
      border-bottom: unset;
    }
    .modal-body {
      padding: 0 3rem 3rem;
    }
    .modal-content {
      border-radius: 8px;
    }
    @mixin btn() {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      border-radius: 100px;
      font-size: 18px;
      height: 50px;
    }
    .btn-alert-error {
      @include btn();
      width: 80%;
    }
    .modal-error-text-main {
      @include fontSize(24);
      @include fontWeight('medium');
      padding: 0px 35px;
    }
    .modal-error-text-sub {
      @include fontSize(14);
      @include fontWeight('light');
    }
    .icon-error {
      width: 90px;
      height: 90px;
    }
  }
}
.close-modal-btn {
  background: transparent;
  border: none;
  color: #29304d;
  font-size: 12px;
  padding: 0;
}
</style>
